import config from 'src/config';

class Logger {
  config = {};

  constructor() {
    this.config = config.get('logger');
  }

  isEnabled(type) {
    return this.config[type] || window.DEBUG_LOGS === true;
  }

  debug() {
    if (this.isEnabled('debug')) console.debug.apply(console, arguments);
  }

  warn() {
    if (this.isEnabled('warn')) console.warn.apply(console, arguments);
  }

  error() {
    if (this.isEnabled('error')) console.error.apply(console, arguments);
  }

  info() {
    if (this.isEnabled('info')) console.info.apply(console, arguments);
  }

  api() {
    if (this.isEnabled('api')) console.log.apply(console, arguments);
  }
  state() {
    if (this.isEnabled('state')) console.log.apply(console, arguments);
  }
  websocket() {
    if (this.isEnabled('websocket')) console.log.apply(console, arguments);
  }
  events() {
    if (this.isEnabled('events')) console.log.apply(console, arguments);
  }
  model() {
    if (this.isEnabled('model')) console.log.apply(console, arguments);
  }
  component() {
    if (this.isEnabled('component')) console.log.apply(console, arguments);
  }
}
const logger = new Logger();
export { logger };
